/**
 * BLOCK - CART SUMMARY - LISTENERS
 */

setupEventListenersForCartSummary();

// Creates the event listeners
function setupEventListenersForCartSummary() {
  // When the value in the "Cart note" field changes
  document.querySelectorAll('.cart__note').forEach((element) => {
    element.addEventListener('change', updateCartNote);
  });
  
  // On clicking on the box to accept the terms and conditions
  document.querySelectorAll('[data-action="accepts-cgv"]').forEach((element) => {
    element.addEventListener('click', toggleCheckoutButton);
  });
  
  // On clicking the button to go to the checkout
  document.querySelectorAll('[data-action="checkout"]').forEach((element) => {
    element.addEventListener('click', clickCheckout);
  });
}

/**
 * BLOCK - CART SUMMARY - GENERAL
 */

// Saves the value of the "Cart note" field
function updateCartNote() {
  const body = JSON.stringify({ note: event.target.value });
  fetch(`${routes.cartUpdateUrl}`, { ...fetchConfig(), ...{ body } });
}

// Enables or disables the "Checkout" button
function toggleCheckoutButton(event) {
  this.querySelector('.input-radio').checked ? enableCheckoutButton(event) : disableCheckoutButton(event);
}

// Activates the "Checkout" button
function enableCheckoutButton(event) {
  var cartSummary = event.target.closest('.cart-summary'),
      buttonCheckout = cartSummary.querySelector('.cart-summary-button').querySelector('.button'),
      cgvText = cartSummary.querySelector('.cart-summary-cgv').querySelector('.input-radio-label-content');
  
  buttonCheckout.removeAttribute('disabled');
  cgvText.classList.remove('blinking-error');
}

// Disables the "Checkout" button
function disableCheckoutButton(event) {
  var cartSummary = event.target.closest('.cart-summary'),
      buttonCheckout = cartSummary.querySelector('.cart-summary-button').querySelector('.button'),
      cgvText = cartSummary.querySelector('.cart-summary-cgv').querySelector('.input-radio-label-content');
  
  buttonCheckout.setAttribute('disabled', 'disabled');
  cgvText.classList.add('blinking-error');
  
  setTimeout(() => {
    cgvText.classList.remove('blinking-error');
  }, 7500);
}

// On clicking the button to go to the checkout
function clickCheckout(event) {
  checkCgv(event);
  checkOutOfStockBundleProducts(event);
}

// Checks if the cgv box is checked
function checkCgv(event) {
  var cartSummary = event.target.closest('.cart-summary'),
      cgvInput = cartSummary.querySelector('.cart-summary-cgv .input-radio');
  
  if (cgvInput && !cgvInput.checked) {
    event.preventDefault();
    disableCheckoutButton(event);
  }
}
  
// Checks if one of the products in one of the bundles is out of stock
function checkOutOfStockBundleProducts(event) {
  var outOfStockItems = event.target.closest('.section__page').querySelector('.list-cart-items').querySelectorAll('.item-cart[data-out-of-stock-bundle-products="true"]');
    
  if (outOfStockItems.length > 0) {
    var modal = document.querySelector('.modal--out-of-stock');
    
    event.preventDefault();
    disableCheckoutButton(event);    
    showModal(modal);
    
    setTimeout(() => {
      outOfStockItems.forEach((element) => {                       
        element.querySelector('.cart-item-remove').click();
      });
    }, 5000);
  }
}